<template>
  <el-dialog
    :title="editForm.id == null || editForm == '' ? $t('xin-zeng-dian-dan-che-zi-fei') : $t('bian-ji-dian-dan-che-zi-fei')"
    :visible="editFormVisible"
    :modal-append-to-body='false'
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id != null && editForm!=''"
    :before-close="clearEditForm">
    <el-form :inline="true" :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">
      <el-form-item :label="$t('deviceControl.operatorId')" :label-width="formLabelWidth" prop="operatorId">
        <el-cascader  size="mini"  ref="cascader"
                      :placeholder="$t('deviceControl.operatorId')" filterable
                      :options="this.setTreeDisable(this.operatorTree)"
                      :props="{checkStrictly:true,expandTrigger:'hover'}"
                      :show-all-levels="false"
                      change-on-select
                      @change='handleChangeOperator'
                      v-model="editForm.operatorId">
        </el-cascader>
      </el-form-item>
      <el-form-item :label="$t('zi-fei-ming-cheng')" :label-width="formLabelWidth" prop="name">
        <el-input v-model="editForm.name" autocomplete="off" :placeholder="$t('qing-shu-ru-zi-fei-ming-cheng')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('kong-zai-deng-dai-shi-jian-miao')" :label-width="formLabelWidth" prop="loadWaitTime">
        <el-input v-model="editForm.loadWaitTime" autocomplete="off" :placeholder="$t('dan-wei-miao')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('chong-man-deng-dai-shi-jian-miao')" :label-width="formLabelWidth" prop="fullWaitTime">
        <el-input v-model="editForm.fullWaitTime" autocomplete="off" :placeholder="$t('dan-wei-miao-0')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('zui-xiao-gong-shuai-w')" :label-width="formLabelWidth" prop="powerMin">
        <el-input v-model="editForm.powerMin" autocomplete="off" :placeholder="$t('dan-wei-w')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('zui-da-gong-shuai-w')" :label-width="formLabelWidth" prop="powerMax">
        <el-input v-model="editForm.powerMax" autocomplete="off" :placeholder="$t('dan-wei-w-0')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('shu-ru-guo-ya-gao-jing-dian')" :label-width="formLabelWidth" prop="inputOvertension">
        <el-input v-model="editForm.inputOvertension" autocomplete="off" :placeholder="$t('dan-wei-v')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('shu-ru-guo-ya-gao-jing-dian-v')" :label-width="formLabelWidth" prop="inputUndervoltage">
        <el-input v-model="editForm.inputUndervoltage" autocomplete="off" :placeholder="$t('dan-wei-v-0')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('dan-lu-shu-chu-guo-liu-gao-jing-dian-a')" :label-width="formLabelWidth" prop="exporOvercurrent">
        <el-input v-model="editForm.exporOvercurrent" autocomplete="off" :placeholder="$t('dan-wei-a')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('dan-lu-shu-chu-guo-liu-dian-a')" :label-width="formLabelWidth" prop="aloneExporOvercurrent">
        <el-input v-model="editForm.aloneExporOvercurrent" autocomplete="off" :placeholder="$t('dan-wei-a-0')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('ji-fei-lei-xing')" :label-width="formLabelWidth" prop="billTypeCode">
        <el-select v-model="editForm.type.code" clearable :placeholder="$t('operatingViewOperator.selectPlaceholder')">
          <el-option
            v-for="item in scooterRateTypeEnum"
            :key="item.value"
            :label="item.message"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!--<el-form-item label="单价(元)" :label-width="formLabelWidth" prop="electricPrice">
        <el-input v-model="editForm.electricPrice" autocomplete="off" placeholder="单位：元"></el-input>
      </el-form-item>-->
      <el-form-item :label="$t('shi-fou-man-dian-duan-kai')" :label-width="formLabelWidth" prop="isFullDisconnect">
        <el-select v-model="editForm.isFullDisconnect" clearable :placeholder="$t('operatingViewOperator.selectPlaceholder')">
          <el-option
            v-for="item in yesNoEnum"
            :key="item.value"
            :label="item.message"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-divider content-position="left" style="padding-top: 20px;"><i class="el-icon-caret-right"></i>
        {{ $t('zi-fei-ming-xi') }}
      </el-divider>
      <el-form-item :label-width="800">
          <el-table :data="editForm.scooterRateDetailList" :border=true style="width: 99.99%;" >
            <el-table-column prop="powerMax" :label="$t('zui-da-gong-shuai')" width="300">
              <template slot-scope="scope">
                <el-input v-model="scope.row.powerMax" autocomplete="off" :placeholder="$t('ji-fei-lei-xing-wei-zui-da-gong-shuai-shi-bi-tian')" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="electricPrice" :label="$t('dian-fei-dan-jia')" width="300">
              <template slot-scope="scope">
                <el-input v-model="scope.row.electricPrice" autocomplete="off" size="small"
                          :placeholder="$t('dan-wei-yuan')"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="servicePrice" label="服务费单价" width="250">
              <template slot-scope="scope">
                <el-input v-model="scope.row.servicePrice" autocomplete="off" size="small"
                          placeholder="单位：元"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('deviceControl.operation')" width="240">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" plain @click="delmembers(scope.$index, scope.row)">{{ $t('deviceControl.delete') }}</el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-button size="mini" type="danger" plain @click="addmembers">{{ $t('jia-yi-hang') }}</el-button>
      </el-form-item>
      <!--隐藏id-->
      <el-form-item hidden style="display: none;" label="id" :label-width="formLabelWidth" prop="id">
        <el-input v-model="editForm.id" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="clearEditForm">{{ $t('qu-xiao') }}</el-button>
      <el-button size="small" type="primary" @click.native="editSubmit"  v-if="checkPermission(['bee:res:rate:scooterRateSave'])" :loading="editSubmitLoading">{{ $t('que-ding') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

  import {validateInput,isIntegerNotMust} from '../../../../common/validator'
  import api from '../../api/scooterRateApi.js';

  export default {
    name: "add",
    data(){
      return{
        openSiteSelect:{},
        editFormRules: {
          operatorId: [{required: true, message: this.$t('monitoringCenter.opsTreePlaceholder'), trigger: 'blur'}],
        },
        formLabelWidth: '150px',
      }
    },
    props:{
      editForm:{},
      editFormVisible:false,
      operatorForSelect:"",
      operatorTree:{
        type: Array,
        required: true
      },
      yesNoEnum:{},
      scooterRateTypeEnum:{},
      stationsForSelect:{},
      pileTypeForSelect:{},
      editSubmitLoading:false
    },
    methods:{
      //  运营商下拉框发生变化
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.editForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      clearEditForm(){
        let _this = this
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm(this.$t('paramMonitor.message18')).then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.$emit("editSubmit", this.$refs.editForm)
      },
      //  加一行
      addmembers() {
        console.log("加一行：" + JSON.stringify(this.editForm.scooterRateDetailList))
        this.editForm.scooterRateDetailList.push({
          powerMax: '',
          electricPrice: '',
          servicePrice: ''
        })
        console.log("加一行：" + JSON.stringify(this.editForm.scooterRateDetailList))
      },
      //  删除一行
      delmembers(index, row) {
        console.log("删除index：" + index)
        var that = this;
        this.$confirm(this.$t('que-ren-shan-chu-ma'), this.$t('deviceControl.prompt'), {
          confirmButtonText: this.$t('deviceControl.confirm'),
          cancelButtonText: this.$t('alaramMonitor.cancel'),
          type: 'warning'
        }).then(() => {
          //点击确定的操作(调用接口)
          that.editForm.scooterRateDetailList.splice(index, 1);
        }).catch(() => {
          //点取消的提示
          return;
        });
      },

    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
    height: auto;
    .el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
      line-height: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/scooterRateManager/add.vue